"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UILoadingOverlay = _interopRequireDefault(require("UIComponents/loading/UILoadingOverlay"));

var AsyncDynoFollowUpEmailPanel = (0, _Loadable.default)({
  delay: 500,
  loader: function loader() {
    return import(
    /* webpackChunkName: "dyno-follow-up-email-panel" */
    'lead-flows-ui/components/editor/DynoFollowUpEmailPanel');
  },
  LoadingComponent: function LoadingComponent(_ref) {
    var pastDelay = _ref.pastDelay;
    return pastDelay ? _react.default.createElement(_UILoadingOverlay.default, {
      contextual: true
    }) : null;
  }
});
var _default = AsyncDynoFollowUpEmailPanel;
exports.default = _default;
module.exports = exports.default;